import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import resolvePath from '../../../misc/resolvePath';
import BlockLink from '../../elements/Blocklink/Blocklink';
import Icon from '../../elements/icons/Icon';
import WaitWhileBusy from '../../WaitWhileBusy';
import enrichmentsConnect from './common/connectEnrichments';
import EnrichmentScreen from './common/EnrichmentScreen';
import RelativeRedirect from '../../elements/RelativeRedirect/RelativeRedirect';

const QuestionItem = props => {
    const {index, id, question, primaryColor, secondaryColor} = props;
    // if(question.show_results === 0)return null;

    return (
        <BlockLink
            style={{borderBottom: '1px solid white', background: 'transparent', display: 'flex', alignItems: 'baseline', padding: '12px 16px'}}
            href={resolvePath(app.history.location.pathname, '..', 'question', id.toString(), 'results', '2')}>
            <h3 style={{color: secondaryColor, marginRight: 25, fontSize: 25, marginTop: 0, marginBottom: 0}}>{index + 1}</h3>
            <p style={{textTransform: 'none'}}>{_.capitalize(question.text)}</p>
            <Icon src={`img/svg/up-graph.svg`} style={{marginLeft: 'auto'}} size={30} />
        </BlockLink>
    );
};

const EnrichmentsResults = props => {
    // NOTE: questions is an array which contains the following: id, number, results & a questions OBJECT.
    const {event, cat, questions, headerColor} = props,
        questionContext = {headerColor, primaryColor: event.settings.primary_color, secondaryColor: event.settings.secondary_color},
        filteredQuestionList = questions.filter(q => parseInt(q.question.show_results) > 1 && !!q.results);

    if (!filteredQuestionList.length) {
        console.log('No results to show: redirect back.');
        return <RelativeRedirect to=".." />;
    }

    return (
        <EnrichmentScreen event={event} enrichmentCategory={cat}>
            {filteredQuestionList.map((item, index) => (
                <QuestionItem key={item.id} {...item} index={index} {...questionContext} />
            ))}
        </EnrichmentScreen>
    );
};

const EnrichmentsHomeConnected = connect(enrichmentsConnect)(EnrichmentsResults);

export default props => (
    <WaitWhileBusy>
        <EnrichmentsHomeConnected {...props.match.params} cat={parseInt(props.match.params.cat)} returnURL={'../..'} />
    </WaitWhileBusy>
);
